import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {ParameterService} from "../../_services/parameter.service";
import {AssociationService} from "./services/association.service";

@Component({
    selector: 'app-association-activity-detail',
    templateUrl: './association-activity-detail.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AssociationActivityDetailComponent extends BaseComponentDirective implements OnInit {

    unitBases: any = {};
    conditionTypes: any = {};
    integerLogics: any = {};

    association: any = {};
    activity: any = {};

    constructor(
        injector: Injector,
        private parameterService: ParameterService,
        private associationService: AssociationService,
    ) {
        super(injector);

    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.conditionTypes = await this.parameterService.getParameterByName("CONDITION_TYPE");
        this.integerLogics = await this.parameterService.getParameterByName("INTEGER_LOGICAL_OPERATOR");
        this.unitBases = await this.parameterService.getParameterByName("UNIT_BASE");

        this.association = await this.associationService.getById(this.activatedRoute.snapshot.params.providerId);
        this.activity = await this.associationService.getByActivityId(this.activatedRoute.snapshot.params.providerId, this.activatedRoute.snapshot.params.providerActivityId);
        this.activity['integerOperatorLabel'] = this.integerLogics.parameterMembers.find((m: any) => m.parameterValue == this.activity.integerOperator)?.parameterLabel;

        console.log(this.activity);
    }

    goEdit() {
        this.router.navigate(['/office/association/detail/' + this.activatedRoute.snapshot.params.providerId + '/activity/'+ this.activatedRoute.snapshot.params.providerActivityId +'/edit']).then()
    }
}
